import { LieferantenGruppe } from '../../shared/lieferantengruppe.model';
export class Fragebogen {
  id: string;
  name: string;
  typ: string;
  ablaufdatum: Date;
  einleitungstext: string;
  schlusstext: string;
  lieferantenGruppen: LieferantenGruppe[] = new Array<LieferantenGruppe>();
  status: number; //0 = nicht beantwortet, 1 = ausstehend, 2 = beantwortet
  ablaufdatumFormat: string;
}
